export default __webpack_public_path__ + "static/media/icon-send-outline.44f1898a.svg";